import { useNossaHistoria } from "@/hooks/useNossaHistoria";

export function Timeline() {
  const { timelineEvents, timelineLoading } = useNossaHistoria();

  if (timelineLoading) {
    return (
      <div className="space-y-px">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="flex gap-8 py-6 animate-pulse">
            <div className="w-16 h-8 bg-gray-200 rounded shrink-0" />
            <div className="flex-1 space-y-2">
              <div className="h-5 bg-gray-200 rounded w-1/3" />
              <div className="h-3 bg-gray-100 rounded w-3/4" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!timelineEvents?.length) return null;

  return (
    <div>
      {timelineEvents.map((event, index) => (
        <div
          key={index}
          className="group grid grid-cols-[5rem_1px_1fr] gap-x-8 py-7 border-b border-gray-100 last:border-b-0 items-start"
        >
          {/* ano */}
          <div className="text-right pt-0.5">
            <span className="text-2xl font-extrabold text-brand-primary/25 font-primary group-hover:text-brand-primary transition-colors duration-300 leading-none">
              {event.year}
            </span>
          </div>

          {/* separador vertical */}
          <div className="relative flex flex-col items-center self-stretch">
            <div className="w-px flex-1 bg-gray-200 group-hover:bg-brand-primary/40 transition-colors duration-300" />
            <div className="w-2 h-2 rounded-full bg-gray-300 group-hover:bg-brand-primary transition-colors duration-300 my-2 shrink-0" />
            <div className="w-px flex-1 bg-gray-200 group-hover:bg-brand-primary/40 transition-colors duration-300" />
          </div>

          {/* conteúdo */}
          <div className="pt-0.5">
            <h3 className="text-base font-bold text-gray-800 font-primary leading-snug mb-1.5 group-hover:text-brand-primary transition-colors duration-300">
              {event.title}
            </h3>
            <p className="text-sm text-gray-500 leading-relaxed">
              {event.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
